import { enablePatches, produceWithPatches } from "immer";
import { filterHelpers } from '../../common/filtering';
import { gEnums } from '../../enums/globalEnums';
import { iconColorTypes } from '../../enums/settingsIconTypes';
import { logPatches } from "./reducerHelpers/logging";
enablePatches();

export const rts = {
  handleAppAreaChange: 'handleAppAreaChange',
  handleCloseGroupItem: 'handleCloseGroupItem',
  handleOpenGroupItem: 'handleOpenGroupItem',
  handleAmmend_menuAuthGroups: 'handleAmmend_menuAuthGroups',
}

export const settingsAreaReducer = (state, action) => {

  const { type, selectedGroupItem } = action
  const { isGlobal } = state ?? {}

  // INIT history store on state (one-time)
  // if (!state.__history) {
  //   state.__history = { past: [], future: [] };
  // }

  // if (type === "__UNDO__") {
  //   const patches = state.__history.past.pop();
  //   if (!patches) return state;

  //   state.__history.future.push(patches.inversePatches);
  //   return applyPatches(state, patches.patches);
  // }

  // if (type === "__REDO__") {
  //   const patches = state.__history.future.pop();
  //   if (!patches) return state;

  //   state.__history.past.push(patches.inversePatches);
  //   return applyPatches(state, patches.patches);
  // }

  const [nextState, patches, inversePatches] = produceWithPatches(
    state,
    draft => {
      switch (action.type) {
        case rts.handleOpenGroupItem:
          draft.selectedGroupItem = action.selectedGroupItem;
          break;

        case rts.handleCloseGroupItem:
          draft.selectedGroupItem = null;
          break;

        case rts.handleAmmend_menuAuthGroups:
          draft.menuAuthGroups = action.menuAuthGroups;
          break;

        case rts.handleAppAreaChange:
          const { baseSettings_state, appAreaStates } = action
          const { projectModules, projectOptions, pageOptions, settingsOptions, productionSettings } = appAreaStates ?? {}

          const { baseSettings, baseSettings_combined, saSplits } = baseSettings_state ?? {}

          const split = saSplits ? {
            authGroups: isGlobal ? saSplits.authGroups.global : saSplits.authGroups.page,
            group: isGlobal ? saSplits.group.global : saSplits.group.page,
            pageItem: isGlobal ? saSplits.pageItem.global : saSplits.pageItem.page,
            prop: isGlobal ? saSplits.prop.global : saSplits.prop.page,
            propSection: isGlobal ? saSplits.propSection.global : saSplits.propSection.page,
          } : {}

          const baseSettings_side = isGlobal ? baseSettings.global : baseSettings.page

          draft.baseSettings = baseSettings
          draft.baseSettings_combined = baseSettings_combined
          draft.baseSettings_side = baseSettings_side
          draft.saSplits = saSplits
          draft.appArea = action.appArea
          draft.menuAuthGroups = split.authGroups
          draft.productionSettings = productionSettings
          draft.projectModules = projectModules
          draft.projectOptions = projectOptions
          draft.pageOptions = pageOptions
          draft.settingsOptions = settingsOptions
          break

        default:
          break;
      }
    }
  );

  return nextState;

};

export const settingsAreaInitialState = (initState) => {
  return { ...initState }
};

export const settingsAreaHandlers = (dispatch) => {
  return {
    handleAppAreaChange: (appArea, isGlobal, baseSettings_state, appAreaStates) => { dispatch({ type: rts.handleAppAreaChange, appArea, isGlobal, baseSettings_state, appAreaStates }) },
    handleOpenGroupItem: (selectedGroupItem) => { dispatch({ type: rts.handleOpenGroupItem, selectedGroupItem }) },
    handleCloseGroupItem: () => { dispatch({ type: rts.handleCloseGroupItem }) },
    handleAmmend_menuAuthGroups: (menuAuthGroups) => { dispatch({ type: rts.handleAmmend_menuAuthGroups, menuAuthGroups }) },
  }
}

export const settingsAreaFunctions = (settingsArea_state) => {
  const { baseSettings_side } = settingsArea_state
  return {
    getCurrentConsoleSettings: (key) => getCurrentConsoleSettings(baseSettings_side, key),
    getSelectedGroupItem: (swipedItem, isGlobal) => getSelectedGroupItem(settingsArea_state, swipedItem, isGlobal),
    ammendDataGroupItem: (swipedItem, updateProps, swipeProps, isGlobal, callOrigin, currSettings) => ammendDataGroupItem(settingsArea_state, swipedItem, updateProps, swipeProps, isGlobal, callOrigin, currSettings),
    getSettingsBaseItem: (key, si) => getSettingsBaseItem(settingsArea_state, key, si),
  }
}

const getSelectedGroupItem = (settingsArea_state, swipedItem, isGlobal) => {

  const { saSplits } = settingsArea_state ?? {}
  const { pageItem, prop, propSection } = saSplits ?? {}

  const _pageItem = isGlobal ? pageItem.global : pageItem.page
  const _prop = isGlobal ? prop.global : prop.page
  const _propSection = isGlobal ? propSection.global : propSection.page

  let selectedGroupItem;

  if (swipedItem.vit) {
    // viewItems
    // returns the items in the vi object
    selectedGroupItem = { groupItems: _.cloneDeep(_pageItem) }
  } else if (swipedItem.pit) {
    // props
    // returns the items in the pr object
    selectedGroupItem = { groupItems: _.cloneDeep(_prop) }
  } else if (swipedItem.psg) {
    // propSections
    // returns the items in the ps object
    selectedGroupItem = { groupItems: _.cloneDeep(_propSection) }
  }

  return selectedGroupItem

}

const ammendDataGroupItem = (settingsArea_state, swipedItem, updateProps, swipeProps, isGlobal_app, callOrigin) => {

  const { baseSettings_combined, isGlobal } = settingsArea_state ?? {}

  const { pageItem: _pageItem, page: _page, global: _global, prop: _prop, propSection: _propSection } = baseSettings_combined ?? {}

  let _isGlobal = isGlobal_app || isGlobal;
  let _side = _isGlobal ? _global : _page;

  // switch (callOrigin) {
  //   // case 'appSettings':
  //   //   _isGlobal = isGlobal_app
  //   //   _side = _isGlobal ? _global : _page
  //   //   break;
  //   default:
  //     _isGlobal = isGlobal
  //     _side = _isGlobal ? _global : _page
  // }

  let selectedGroupItem;

  // the selectedGroupItem will contain the groupItems

  if (updateProps && updateProps.vit) {
    if (updateProps.pit) {
      // take from props objects
      selectedGroupItem = _prop && _prop[swipeProps.key]
    } else if (updateProps.psg) {
      // take from propSettings objects 
      selectedGroupItem = _propSection && _propSection[swipeProps.key]
    } else {
      // take from viewItem objects 
      selectedGroupItem = _pageItem && _pageItem[swipeProps.key]
    }
  } else {
    if (updateProps && updateProps.subKey) {
      switch (updateProps.subKey) {
        case 'dataListItem': // LOOK 
          selectedGroupItem = _global && _global[swipedItem.key]
          swipeProps.viewProps = selectedGroupItem
          break;
        default:
          selectedGroupItem = _global && _global[swipedItem.key]
          swipeProps.viewProps = selectedGroupItem
      }
    } else {
      // take from view objects 
      // console.log('looking for ...', isGlobal, swipedItem.key, swipedItem)
      selectedGroupItem = _side && _side[swipedItem.key]
      swipeProps.viewProps = selectedGroupItem
    }
  }

  const _sideItem = _side ? _side[swipedItem.key] : null

  const { allowSettingsUpdate, settingsUpdateHandler, settingsUpdateHandlerFunction } = _sideItem ?? {}
  if (allowSettingsUpdate && settingsUpdateHandler && settingsUpdateHandlerFunction) {
    swipeProps.formHandler = {
      allowSettingsUpdate,
      settingsUpdateHandler,
      settingsUpdateHandlerFunction
    }
  }

  return selectedGroupItem

}

const getSettingsBaseItem = (settingsArea_state, key, si) => {

  const { baseSettings_combined } = settingsArea_state ?? {}
  const { pageItem, global, prop, propSection } = baseSettings_combined ?? {}

  const sub = si ? si : 'groupItems'

  if (global[key]) {
    const _global = _.cloneDeep(global)
    return _global[key][sub]
  }

  if (pageItem[key]) {
    const _pageItem = _.cloneDeep(pageItem)
    return _pageItem[key][sub]
  }

  if (prop[key]) {
    const _prop = _.cloneDeep(prop)
    return _prop[key][sub]
  }

  if (propSection[key]) {
    const _propSection = _.cloneDeep(propSection)
    return _propSection[key][sub]
  }
}

const getCurrentConsoleSettings = (baseSettings_side, key) => {
  if (baseSettings_side[key]) {
    return baseSettings_side[key]
  }
}